module.exports = __webpack_public_path__ + "static/media/thumbnail.b2867ac9.jpg";